var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.9997 9.33333C10.8951 9.33333 9.99967 8.4379 9.99967 7.33333C9.99967 6.22876 10.8951 5.33333 11.9997 5.33333C13.1042 5.33333 13.9997 6.22876 13.9997 7.33333C13.9997 8.4379 13.1042 9.33333 11.9997 9.33333ZM5.99967 7.33333C4.52692 7.33333 3.33301 6.13943 3.33301 4.66667C3.33301 3.19391 4.52692 2 5.99967 2C7.47243 2 8.66634 3.19391 8.66634 4.66667C8.66634 6.13943 7.47243 7.33333 5.99967 7.33333Z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7341 10.0004C14.0051 10.0252 15.8595 11.1734 15.999 13.6C16.0046 13.6977 15.999 14 15.6373 14H13.0667C13.0667 12.4993 12.5709 11.1145 11.7341 10.0004ZM0.000434456 13.4661C0.258839 10.2843 2.84127 8.66663 5.98889 8.66663C9.18081 8.66663 11.8033 10.1954 11.9986 13.4666C12.0064 13.5969 11.9986 14 11.4978 14C9.02742 14 5.35648 14 0.485002 14C0.317808 14 -0.0136412 13.6394 0.000434456 13.4661Z",
    fill: "#323130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.3bda7bbc.svg";
export { ForwardRef as ReactComponent };